module.exports = {"id":"230072","name":"Riad Bajić","rating":"72","photo":"./data/images/photos/4/230072.png","club":{"name":"Medipol Başakşehir","logo":"./data/images/clubs/MedipolBasaksehir.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RiadBajic0.json
// module id = 3583
// module chunks = 0